import React, { createContext, useContext } from "react";
import { getDynamicStyles } from "./styles";

interface FontSizeContextType {
  fontSize: string;
  dynamicStyles: ReturnType<typeof getDynamicStyles>;
}

const FontSizeContext = createContext<FontSizeContextType | null>(null);

export const FontSizeProvider = ({
  fontSize,
  children,
}: {
  fontSize: string;
  children: React.ReactNode;
}) => {
  const dynamicStyles = getDynamicStyles(fontSize);
  
  return (
    <FontSizeContext.Provider value={{ fontSize, dynamicStyles }}>
      {children}
    </FontSizeContext.Provider>
  );
};

export const useFontSize = () => {
  const context = useContext(FontSizeContext);
  if (!context) {
    // Fallback to default fontSize if context is not available
    return {
      fontSize: "11",
      dynamicStyles: getDynamicStyles("11"),
    };
  }
  return context;
};
